export default __webpack_public_path__ + "static/media/daylight_wireframe.f3e137d9.png";